<template>
  <layout-horizontal>

    <router-view />

    <template #navbar="{ toggleVerticalMenuActive }">
      <app-navbar-horizontal-layout-brand />
      <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
    </template>

    <!-- <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    /> -->
  </layout-horizontal>
</template>

<script>
import LayoutHorizontal from '@core/layouts/layout-horizontal/LayoutHorizontal.vue'
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import AppNavbarHorizontalLayoutBrand from '@core/layouts/components/app-navbar/AppNavbarHorizontalLayoutBrand.vue'
import Navbar from '../components/Navbar.vue'
import {
  isUserLoggedIn
} from "@/auth/utils";
import { isAdministrator } from "@/auth/utils";
import {
  initialAbility
} from "@/libs/acl/config";
import { eventBus } from '@/main';

export default {
  components: {
    LayoutHorizontal,
    // AppCustomizer,
    Navbar,
    AppNavbarHorizontalLayoutBrand,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    }
  },
  mounted() {
    if (!isUserLoggedIn()) {
      this.logout();
    } else {
      if (!isAdministrator()) {
        this.$store.dispatch('app-portaldata/COUNT_ORDER_LINES');
        this.$store.dispatch('app-userdata/INIT_USER_DATA').catch(() => this.$router.push({ name: 'error' }));
      }
      this.$store.dispatch('app-portaldata/INITIALIZE_PRODUCTS_LIST').catch(() => this.$router.push({ name: 'error' }));
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('app-userdata/logout').catch(error => console.log(error.response)).finally(() => {
        this.$ability.update(initialAbility)
        this.$router.push({ name: 'auth-login' })
        this.$forceUpdate()
      })
    }
  },
  created() {
    eventBus.$on('show-sweetalert-error', error => {
      if (error.status == 403) {
        this.$ability.update(initialAbility)
        this.$router.push({ name: 'auth-login' })
        this.$forceUpdate()
      }
    });
  }
}
</script>
